/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { FormControl, IconButton } from "@material-ui/core";
import { formatDateToBR } from "../../../utils/time";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { Calendar, DayRange, DayValue } from "react-modern-calendar-datepicker";
import styles from "../../../pages/dashboard/styles.module.scss";
import moment from "moment/moment";
import { RiCalendarTodoLine } from "react-icons/ri";

type FiltersProps = {
  dataInicial?: string;
  dataFinal?: string;
};

const myCustomLocale = {
  // months list by order
  months: [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ],

  weekDays: [
    {
      name: "Domingo", // used for accessibility
      short: "D", // displayed at the top of days' rows
      isWeekend: true, // is it a formal weekend or not?
    },
    {
      name: "Segunda",
      short: "S",
    },
    {
      name: "terça",
      short: "T",
    },
    {
      name: "Quarta",
      short: "Q",
    },
    {
      name: "Quinta",
      short: "Q",
    },
    {
      name: "Sexta",
      short: "S",
    },
    {
      name: "Sábado",
      short: "S",
      isWeekend: true,
    },
  ],

  // just play around with this number between 0 and 6
  weekStartingIndex: 0,

  // return a { year: number, month: number, day: number } object
  getToday(gregorainTodayObject: any) {
    return gregorainTodayObject;
  },

  // return a native JavaScript date here
  toNativeDate(date: any) {
    return new Date(date.year, date.month - 1, date.day);
  },

  // return a number for date's month length
  getMonthLength(date: any) {
    return new Date(date.year, date.month, 0).getDate();
  },

  // return a transformed digit to your locale
  transformDigit(digit: any) {
    return digit;
  },

  // texts in the date picker
  nextMonth: "Next Month",
  previousMonth: "Previous Month",
  openMonthSelector: "Open Month Selector",
  openYearSelector: "Open Year Selector",
  closeMonthSelector: "Close Month Selector",
  closeYearSelector: "Close Year Selector",
  defaultPlaceholder: "Select...",

  // for input range value
  from: "from",
  to: "to",

  // used for input value when multi dates are selected
  digitSeparator: ",",

  // if your provide -2 for example, year will be 2 digited
  yearLetterSkip: 0,

  // is your language rtl or ltr?
  isRtl: false,
};

type ModalCalendarProps = {
  showDialog: boolean;
  handleCloseModal: () => void;
  handleApplyRangeDate: (value: any) => void;
  reset?: boolean;
};
const ModalCalendar: React.FC<ModalCalendarProps> = ({
  showDialog,
  handleCloseModal,
  handleApplyRangeDate,
  reset,
}) => {
  // pegar ano atual com o moment e subtrair 2019
  const anoAtual = moment().format("YYYY");
  const anoAtualSubtrair = Number(anoAtual) - 2019;

  const [filters, setFilters] = useState<FiltersProps>({});

  const [labelSideMenu, setLabelSideMenu] = useState("Personalizado");

  const dataModalFilterStart = moment()
    .startOf("year")
    .format("YYYY-MM-DD")
    .split("-");

  const dataModalFilterEnd = moment().format("YYYY-MM-DD").split("-");

  const defaultFrom = {
    year: Number(dataModalFilterStart[0]),
    month: Number(dataModalFilterStart[1]),
    day: Number(dataModalFilterStart[2]),
  };

  const defaultTo = {
    year: Number(dataModalFilterEnd[0]),
    month: Number(dataModalFilterEnd[1]),
    day: Number(dataModalFilterEnd[2]),
  };

  const defaultRange = {
    from: defaultTo,
    to: defaultFrom,
  };

  const [selectedDayRange, setSelectedDayRange] =
    useState<DayRange>(defaultRange);

  const handleDateSetFilter = (dateStart: any, dateEnd?: any) => {
    if (!dateEnd) {
      dateEnd = dateStart;
    }
    setSelectedDayRange({
      from: {
        year: Number(dateStart[0]),
        month: Number(dateStart[1]),
        day: Number(dateStart[2]),
      },
      to: {
        year: Number(dateEnd[0]),
        month: Number(dateEnd[1]),
        day: Number(dateEnd[2]),
      },
    });
    setFilters({
      dataInicial: `${dateStart[0]}-${dateStart[1]}-${dateStart[2]}`,
      dataFinal: `${dateEnd[0]}-${dateEnd[1]}-${dateEnd[2]}`,
    });
  };

  useEffect(() => {
    if (reset) {
      setSelectedDayRange(defaultRange);
      setFilters({});
    }
  }, [reset]);

  const sideMenu = [
    {
      label: "Hoje",
      onPress: () => {
        setLabelSideMenu("Hoje");
        const data = moment().format("YYYY-MM-DD").split("-");
        handleDateSetFilter(data);
      },
    },
    {
      label: "Ontem",
      onPress: () => {
        setLabelSideMenu("Ontem");
        const data = moment().add(-1, "days").format("YYYY-MM-DD").split("-");
        handleDateSetFilter(data);
      },
    },

    {
      label: "Esta semana",
      onPress: () => {
        setLabelSideMenu("Esta semana");
        const dataStart = moment()
          .startOf("isoWeek")
          .format("YYYY-MM-DD")
          .split("-");

        const dataEnd = moment()
          .endOf("isoWeek")
          .format("YYYY-MM-DD")
          .split("-");

        handleDateSetFilter(dataStart, dataEnd);
      },
    },

    {
      label: "Semana Passada",
      onPress: () => {
        setLabelSideMenu("Semana Passada");
        const dataStart = moment()
          .subtract(1, "weeks")
          .startOf("isoWeek")
          .format("YYYY-MM-DD")
          .split("-");

        const dataEnd = moment()
          .subtract(1, "weeks")
          .endOf("isoWeek")
          .format("YYYY-MM-DD")
          .split("-");

        handleDateSetFilter(dataStart, dataEnd);
      },
    },

    {
      label: "Últimos 7 dias",
      onPress: () => {
        setLabelSideMenu("Últimos 7 dias");
        const dataStart = moment()
          .add(-6, "days")
          .format("YYYY-MM-DD")
          .split("-");
        const dataEnd = moment().format("YYYY-MM-DD").split("-");

        handleDateSetFilter(dataStart, dataEnd);
      },
    },

    {
      label: "Últimos 28 dias",
      onPress: () => {
        setLabelSideMenu("Últimos 28 dias");
        const dataStart = moment()
          .add(-27, "days")
          .format("YYYY-MM-DD")
          .split("-");
        const dataEnd = moment().format("YYYY-MM-DD").split("-");
        handleDateSetFilter(dataStart, dataEnd);
      },
    },

    {
      label: "Últimos 30 dias",
      onPress: () => {
        setLabelSideMenu("Últimos 30 dias");
        const dataStart = moment()
          .add(-29, "days")
          .format("YYYY-MM-DD")
          .split("-");
        const dataEnd = moment().format("YYYY-MM-DD").split("-");
        handleDateSetFilter(dataStart, dataEnd);
      },
    },

    {
      label: "Últimos 90 dias",
      onPress: () => {
        setLabelSideMenu("Últimos 90 dias");
        const dataStart = moment()
          .add(-89, "days")
          .format("YYYY-MM-DD")
          .split("-");
        const dataEnd = moment().format("YYYY-MM-DD").split("-");
        handleDateSetFilter(dataStart, dataEnd);
      },
    },

    {
      label: "Últimos 12 meses",
      onPress: () => {
        setLabelSideMenu("Últimos 12 meses");
        const dataStart = moment()
          .subtract(12, "months")
          .startOf("month")
          .format("YYYY-MM-DD")
          .split("-");
        const dataEnd = moment().format("YYYY-MM-DD").split("-");
        handleDateSetFilter(dataStart, dataEnd);
      },
    },

    {
      label: "Ano passado",
      onPress: () => {
        setLabelSideMenu("Ano passado");
        const dataStart = moment()
          .subtract(1, "year")
          .startOf("year")
          .format("YYYY-MM-DD")
          .split("-");
        const dataEnd = moment()
          .subtract(1, "year")
          .endOf("year")
          .format("YYYY-MM-DD")
          .split("-");
        handleDateSetFilter(dataStart, dataEnd);
      },
    },

    {
      label: "Este ano (Jan - Hoje)",
      onPress: () => {
        setLabelSideMenu("Este ano (Jan - Hoje)");
        const dataStart = moment()
          .startOf("year")
          .format("YYYY-MM-DD")
          .split("-");
        const dataEnd = moment().format("YYYY-MM-DD").split("-");
        handleDateSetFilter(dataStart, dataEnd);
      },
    },
    {
      label: "Consolidado (2019 - Hoje)",
      onPress: () => {
        setLabelSideMenu("Consolidado (2019 - Hoje)");
        const dataStart = moment()
          .subtract(anoAtualSubtrair, "year")
          .startOf("year")
          .format("YYYY-MM-DD")
          .split("-");
        const dataEnd = moment().format("YYYY-MM-DD").split("-");
        handleDateSetFilter(dataStart, dataEnd);
      },
    },

    {
      label: "Personalizado",
      onPress: () => {
        setLabelSideMenu("Personalizado");
        const dataStart = moment().format("YYYY-MM-DD").split("-");
        const dataEnd = moment().format("YYYY-MM-DD").split("-");
        handleDateSetFilter(dataStart, dataEnd);
      },
    },
  ];

  return (
    <Modal
      open={showDialog}
      onClose={handleCloseModal}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          borderRadius: 4,
          p: 2,
        }}
      >
        <div className="grid-container">
          <div className="grid-item item2">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: -5,
              }}
            >
              <div>
                <p className="personalizado-range-dataLabel">{labelSideMenu}</p>
                <div className="personalizado-range-data">
                  <p
                    className="personalizado-range-data"
                    style={{
                      background:
                        filters?.dataInicial || filters?.dataFinal
                          ? "#DDF8FF"
                          : "transparent",
                    }}
                  >
                    {filters?.dataInicial || filters?.dataFinal
                      ? `${formatDateToBR(filters?.dataInicial)}`
                      : ""}
                  </p>
                  <span style={{ margin: 2, fontSize: 13 }}>
                    {filters?.dataInicial || filters?.dataFinal ? "-" : ""}
                  </span>

                  <p
                    className="personalizado-range-data"
                    style={{
                      background:
                        filters?.dataInicial || filters?.dataFinal
                          ? "#DDF8FF"
                          : "transparent",
                    }}
                  >
                    {filters?.dataInicial || filters?.dataFinal
                      ? `${formatDateToBR(filters?.dataFinal)}`
                      : ""}
                  </p>
                </div>
              </div>
              <div className="close-icon-range-date">
                <AiOutlineCloseCircle
                  style={{ color: "#bdbdbd", fontWeight: "bold" }}
                  onClick={handleCloseModal}
                />
              </div>
            </div>

            <div className="calendar">
              <Calendar
                value={selectedDayRange}
                onChange={(value: DayRange) => {
                  setSelectedDayRange(value);
                  // handleApplyRangeDate(value);
                }}
                colorPrimary="#0fbcf9"
                colorPrimaryLight="rgba(75, 207, 250, 0.4)"
                calendarClassName={styles.responsive_calendar}
                locale={myCustomLocale}
                shouldHighlightWeekends
              />
            </div>
          </div>

          <div className="grid-item item1">
            {sideMenu.map((item, index) => (
              <p
                key={index.toString()}
                onClick={item.onPress}
                style={{
                  cursor: "pointer",
                  color: item.label === labelSideMenu ? "#18A0FB" : "#000",
                }}
              >
                {item.label}
              </p>
            ))}
          </div>
        </div>
        <hr className="divisor" />

        <div className="buttonSpan">
          <span className="cancel" onClick={handleCloseModal}>
            Cancelar
          </span>
          <button
            className={
              !selectedDayRange.to || !selectedDayRange.from
                ? "apply-disable"
                : "apply"
            }
            disabled={!selectedDayRange.to || !selectedDayRange.from}
            onClick={() => {
              handleApplyRangeDate(selectedDayRange);
              handleCloseModal();
            }}
          >
            Aplicar
          </button>
        </div>
      </Box>
    </Modal>
  );
};

type SEDateRangePickerProps = {
  onChange?: (value: any) => void;
  reset?: boolean;
  disabled?: boolean;
  value?: { startDate: string; endDate: string };
};

function formatDateForTextField(startDate: string, endDate: string) {
  const formattedStartDate = startDate
    ? moment(startDate).format("DD/MM/YYYY")
    : "";
  const formattedEndDate = endDate ? moment(endDate).format("DD/MM/YYYY") : "";
  return `${formattedStartDate} - ${formattedEndDate}`;
}
export const SEDateRangePicker: React.FC<SEDateRangePickerProps> = ({
  value,
  onChange,
  reset,
  disabled,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [textFieldValue, setTextFieldValue] = useState("");

  useEffect(() => {
    if (reset) {
      setTextFieldValue("");
    }
  }, [reset]);

  useEffect(() => {
    if (!value?.startDate && !value?.endDate) {
      setTextFieldValue("");
    } else {
      const formattedDates = formatDateForTextField(
        value.startDate,
        value.endDate
      );
      setTextFieldValue(formattedDates);
    }
  }, [value]);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  function formatDayRangeToDateStrings(dayRange: DayRange) {
    if (!dayRange || !dayRange.from || !dayRange.to) {
      return { startDate: "", endDate: "" }; // Retorna valores padrão ou vazios se não houver DayRange ou valores inválidos
    }
    const formatDate = (day: DayValue) => {
      if (!day) return "";
      return `${day.year}-${String(day.month).padStart(2, "0")}-${String(
        day.day
      ).padStart(2, "0")}`;
    };

    const startDate = formatDate(dayRange.from);
    const endDate = formatDate(dayRange.to);
    return { startDate, endDate };
  }

  const handleApplyRangeDate = (value: any) => {
    if (onChange) {
      const { startDate, endDate } = formatDayRangeToDateStrings(value);
      const formattedDates = formatDateForTextField(startDate, endDate);
      setTextFieldValue(formattedDates); // Define o valor formatado no estado do TextField
      onChange(formatDayRangeToDateStrings(value)); // Chama a função de onChange passando as datas formatadas
    }
  };

  return (
    <>
      <FormControl fullWidth>
        <TextField
          disabled={disabled}
          value={textFieldValue}
          placeholder="Data início | Data fim"
          label="Período"
          id="modal-textfield"
          onClick={!disabled ? handleOpenModal : undefined}
          variant="outlined"
          InputProps={{
            endAdornment: (
              <IconButton disabled={disabled}>
                <RiCalendarTodoLine color={"#0041D9"} />
              </IconButton>
            ),
          }}
        />
      </FormControl>

      <ModalCalendar
        showDialog={openModal}
        handleCloseModal={handleCloseModal}
        handleApplyRangeDate={handleApplyRangeDate}
        reset={reset}
      />
    </>
  );
};
